import * as Sentry from "@sentry/nextjs";
import { env } from "env";
import posthog from "posthog-js";

const isProductionDeployment =
  env.NEXT_PUBLIC_APP_ENV === "production" || env.NEXT_PUBLIC_APP_ENV === "staging";

// SENTRY_AUTH_TOKEN is build-only; client init uses the DSN below.
if (isProductionDeployment) {
  Sentry.init({
    dsn: "https://fd0bd6638651a9975e3b7809d12f5565@o1428761.ingest.us.sentry.io/4509809603772416",

    sendDefaultPii: false,

    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],

    tracesSampleRate: 0.1,
    enableLogs: true,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,

    debug: false,
  });
}

export const onRouterTransitionStart = isProductionDeployment
  ? Sentry.captureRouterTransitionStart
  : () => {};

// PostHog API host (eu.i.posthog.com) differs from the app UI host (eu.posthog.com).
const posthogUiHost = env.NEXT_PUBLIC_POSTHOG_HOST.replace(".i.posthog.com", ".posthog.com");

if (isProductionDeployment && env.NEXT_PUBLIC_POSTHOG_KEY) {
  posthog.init(env.NEXT_PUBLIC_POSTHOG_KEY, {
    api_host: env.NEXT_PUBLIC_POSTHOG_INGEST,
    ui_host: posthogUiHost,
    defaults: "2025-05-24",
    capture_dead_clicks: true,
    capture_pageview: "history_change",
    capture_pageleave: "if_capture_pageview",
    capture_exceptions: true,
    capture_heatmaps: true,
    capture_performance: true,
    // debug: env.NEXT_PUBLIC_POSTHOG_ENVIRONMENT === "development",
  });
}
